import React, {Component} from 'react';

import {Grid} from '@material-ui/core';
import _ from "lodash";
import {connect} from "react-redux";

import './styles.scss';
import Select from '../common/select';
import PorcentageGraph from './components/porcentageGraph'

import product from "../../../assets/product-profile.png";
import male from "../../../assets/male-profile.png";
import ageRange from "../../../assets/age-profile.png";
import bbva from "../../../assets/bbva-profile.png";


import axios from "axios/index";
import {tokenHeader} from "../../../utils/headers";
import urls from "../../../utils/urls";
import {ajaxHandler} from "../../../utils/errors";
import LoadingSpinner from "../../../components/spinner/Spinner";
import AxisLines from "./components/axisLines";
import Title from "../common/title/Title";
import GroupTitle from "./components/groupTitle/GroupTitle";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";
import translator from "../../../utils/translations";


class OurPartners extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedBtn: {label: "Boca vs. País", key: "country"},
            age_rank_data: false,
            is_bbva_data: false,
            member_gender_data: false,
            product_data: false,
            xhr: false,
            axiosSource: null
        }
    }

    _emptyStateAndLoad = () => {
        this.setState({
            age_rank_data: [],
            is_bbva_data: [],
            member_gender_data: [],
            product_data: []
        }, this._fetchData);
    };

    _handleBtnSelection = (selector) => {
        this.setState({
            selectedBtn: selector,
        }, this._emptyStateAndLoad);
    };

    componentDidMount(){
        if (this.props.stations.list) {
            if (this.props.filters) {
                this.setState({selectedValue: this.props.filters[this.props.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((this.props.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (this.props.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (this.props.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._fetchData();
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            if (nextProps.filters) {
                this.setState({selectedValue: nextProps.filters[nextProps.filters.length - 1]}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._emptyStateAndLoad();
                }
            }
        }
    }

    onValueChange = (ev) => {
        this.setState({
            selectedValue: ev.target.value,
        }, this._emptyStateAndLoad)
    };

    _fetchData = () => {
        let maxmin_url = `${urls.API_ROOT}/api/v1/max-min-avg-graph/?quarter=${this.state.selectedValue ?
            this.state.selectedValue.quarter : "Q3"}&year=${this.state.selectedValue ? this.state.selectedValue.year : "2018"}&scope=${this.state.selectedBtn.key}`;
        if (this.props.navigation.selectedArea !== -1) {
            maxmin_url = maxmin_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
        }
        if (this.props.navigation.selectedZone !== -1) {
            maxmin_url = maxmin_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
        }
        if (this.props.navigation.selectedStation !== -1) {
            maxmin_url = maxmin_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }

        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        axios
            .get(maxmin_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {
                let {data} = response;
                console.log(data);

                let ageRanks = ['from_18_to_34', 'from_35_to_44', 'from_45_to_64', 'from_45_to_64', 'more_than_64'];
                let products = ['super', 'switch_sub', 'switch_plus', 'v_power'];

                this.setState({
                    age_rank_data: data.filter(each => (ageRanks).indexOf(each.field) > -1),
                    is_bbva_data: data.filter(each => each.field === 'bbva'),
                    member_gender_data: data.filter(each => each.field === 'gender'),
                    product_data: data.filter(each => (products).indexOf(each.field) > -1),
                    axiosSource: null,
                    xhr: false
                })
            })
            .catch(ajaxHandler);
    };

    render() {
        const values = this.props.filters;

        let selectors = [{label: "Boca vs. País", key: "country"}, {
            label: "Boca vs. Nivel DM",
            key: "area"
        }, {label: "Boca vs. Nivel TM", key: "zone"}];

        let selectorsButtons = <div className="selector-btn"
                                    style={{position: 'relative', display: 'inline-block', marginRight: 20}}>
            {
                selectors.map((btn) => {
                    let disable = (btn.key === "area" && (!this.props.navigation.selectedArea || this.props.navigation.selectedArea === -1)) ||
                        (btn.key === "zone" && (!this.props.navigation.selectedZone || this.props.navigation.selectedZone === -1));
                    let li_class = (btn.key === this.state.selectedBtn.key) ? ' active inline-block' : 'inline-block';
                    if (disable) {
                        li_class = 'disabled inline-block';
                    }
                    return (
                        <div key={btn} className={li_class} style={{
                            backgroundColor: disable ? '#E9E9E9' : '#fff',
                            cursor: disable ? 'default' : 'pointer'
                        }}
                             onClick={() => {
                                 if (!disable) {
                                     this._handleBtnSelection(btn)
                                 }
                             }}>
                            <span className="hide-on-med-and-down">{btn.label}</span>
                        </div>
                    );
                })
            }
        </div>;

        let member_gender_data_avg = {};
        if (this.state.member_gender_data.length > 0) {
            member_gender_data_avg = this.state.member_gender_data[0].data.find(e => e.type === 'station');
        }
        let member_gender_data = {};
        if (this.state.member_gender_data.length > 0) {
            member_gender_data = this.state.member_gender_data[0].data.find(e => e.type !== 'station');
        }

        let bbva_data_avg = {};
        if (this.state.is_bbva_data.length > 0) {
            bbva_data_avg = this.state.is_bbva_data[0].data.find(e => e.type === 'station');
        }
        let bbva_data = {};
        if (this.state.is_bbva_data.length > 0) {
            bbva_data = this.state.is_bbva_data[0].data.find(e => e.type !== 'station');
        }

        return (
            <div className={'our-partners-section container'}>
                <Title>Perfil de sus socios</Title>
                <div className={"navigation-top"}>
                    {selectorsButtons}
                    <Select className={"select graphics-form"} values={values}
                            selectedValue={this.state.selectedValue}
                            onValueChange={this.onValueChange}/>
                </div>
                {this.state.product_data.length > 0 && this.state.is_bbva_data.length > 0 &&
                this.state.age_rank_data.length > 0 && this.state.member_gender_data.length > 0 &&
                <div>
                    <Grid container spacing={16}>
                        <Grid item xs={3}>
                            {this.state.member_gender_data &&
                            <div className={"group-section"}>
                                <GroupTitle img={male} name={"Masculino"}/>
                                <div className={"graph"}>
                                    <div className={"axis"}>
                                        <AxisLines/>
                                    </div>
                                    <PorcentageGraph
                                        top={member_gender_data ? _.round(member_gender_data.maximum) : 0}
                                        bottom={member_gender_data ? _.round(member_gender_data.minimun) : 0}
                                        value={member_gender_data_avg ? _.round(member_gender_data_avg.average) : -1}
                                        percentage={member_gender_data ? _.round(member_gender_data.average) : 0}/>
                                </div>
                            </div>}
                        </Grid>
                        <Grid item xs={9}>
                            {this.state.age_rank_data &&
                            <div className={"group-section"}>
                                <GroupTitle img={ageRange} name={"Rango Etario"}/>
                                <div className={"graph"}>
                                    <div className={"axis"} style={{width: '90%'}}>
                                        <AxisLines/>
                                    </div>
                                    {this.state.age_rank_data.map((age_rank, i) => {
                                        let age_rank_station_avg = (_.filter(age_rank.data, (rank) => {
                                            return rank.type === 'station'
                                        }))[0];
                                        let age_rank_data = (_.filter(age_rank.data, (rank) => {
                                            return rank.type !== 'station'
                                        }))[0];
                                        return <PorcentageGraph
                                            key={i}
                                            top={age_rank_data ? _.round(age_rank_data.maximum) : 0}
                                            bottom={age_rank_data ? _.round(age_rank_data.minimun) : 0}
                                            value={age_rank_station_avg ? _.round(age_rank_station_avg.average) : -1}
                                            percentage={age_rank_data ? _.round(age_rank_data.average) : 0}
                                            comment={translator.getFieldName(age_rank.field)}/>
                                    })}
                                </div>
                            </div>}
                        </Grid>
                    </Grid>
                    <Grid container spacing={16}>
                        <Grid item xs={3}>
                            {this.state.is_bbva_data &&
                            <div className={"group-section"}>
                                <GroupTitle img={bbva} name={"BBVA"}/>
                                <div className={"graph"}>
                                    <div className={"axis"}>
                                        <AxisLines/>
                                    </div>
                                    <PorcentageGraph
                                        top={bbva_data ? _.round(bbva_data.maximum) : 0}
                                        bottom={bbva_data ? _.round(bbva_data.minimun) : 0}
                                        value={bbva_data_avg ? _.round(bbva_data_avg.average) : -1}
                                        percentage={bbva_data ? _.round(bbva_data.average) : 0}/>
                                </div>
                            </div>}
                        </Grid>
                        <Grid item xs={9}>
                            {this.state.product_data &&
                            <div className={"group-section"}>
                                <GroupTitle img={product} name={"Producto *"}/>

                                <div className={"graph"}>
                                    <div className={"axis"} style={{width: '90%'}}>
                                        <AxisLines/>
                                    </div>
                                    {this.state.product_data.map((product_data, i) => {
                                        // console.log(product_data);
                                        let product_station_avg = (_.filter(product_data.data, (rank) => {
                                            return rank.type === 'station'
                                        }))[0];
                                        let product = (_.filter(product_data.data, (rank) => {
                                            return rank.type !== 'station'
                                        }))[0];

                                        return <PorcentageGraph
                                            key={i}
                                            top={product ? _.round(product.maximum) : 0}
                                            bottom={product ? _.round(product.minimun) : 0}
                                            value={product_station_avg ? _.round(product_station_avg.average) : -1}
                                            percentage={product ? _.round(product.average) : 0}
                                            comment={translator.getFieldName(product_data.field)}/>
                                    })}
                                </div>
                            </div>}
                            <div className={"product-clarification"}>(*) Calculado en función de los últimos 6
                                trimestres
                            </div>
                        </Grid>
                    </Grid>
                </div>}
                {(!this.state.member_gender_data || !this.state.age_rank_data || !this.state.is_bbva_data || !this.state.product_data) &&
                <VerticalAlign>
                    <LoadingSpinner className={'spinner'} width={50}/>
                </VerticalAlign>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        navigation: state.navigation,
        stations: state.stations
    }
};

export default connect(mapStateToProps)(OurPartners);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/OurPartners.js